import styled from 'styled-components'

export const Icon = styled.img`
  vertical-align: text-top;
  margin-right: 0.5rem;
`